import { customFieldRepository } from '@webapp/core/data-access/repositories/CustomFieldRepository/CustomFieldRepository'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'

const base = ['customFields']

export const customFieldQueryConfig = {
  getAPItemCustomFields: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'apItem']),
    queryFn: () => customFieldRepository.getAPItemCustomFields(params),
  }),
  getSpendingCardCustomFields: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'spendingCard']),
    queryFn: () => customFieldRepository.getSpendingCardCustomFields(params),
  }),
  /** Base-key member for invalidation — matches every PO custom-field query */
  allPurchaseOrder: () => ({
    queryKey: buildQueryKey([...base, 'purchaseOrder']),
  }),
  getPurchaseOrderCustomFields: (params: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'purchaseOrder', 'list', params]),
    queryFn: () => customFieldRepository.getPurchaseOrderCustomFields(params),
  }),
}
